module.exports = __webpack_public_path__ + "img/DB1GROUP_BANNER.51996e91.png";